import Paper from '@base/Paper/Paper';
import styled from '@emotion/styled';
import H1 from '@base/H1/H1';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import Image from '@base/Image';
import { Spacings, mediaQuery, Fonts } from '@styles/index';

const Wrapper = styled(Paper)`
  border-radius: 0;
  padding-top: ${Spacings.SPACING_24B};
  padding-left: 115px;
  background-color: var(--color-base-0);
  margin-bottom: -${Spacings.SPACING_HEADER_MARGIN}px;
  padding-bottom: ${Spacings.SPACING_24B};

  ${mediaQuery.uptoTablet} {
    padding-left: 0;
    padding-right: 0;
  }

  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    padding-top: ${Spacings.SPACING_12B};
    padding-left: 0;
    padding-right: 0;
  }
`;

const StyledH1 = styled(H1)`
  width: 395px;
  ${mediaQuery.uptoTablet} {
    width: 250px;
  }
`;

const BenefitsContainer = styled.div`
  margin-top: ${Spacings.SPACING_20B};
  display: flex;
  justify-content: space-between;
  ${mediaQuery.uptoMobile} {
    height: 700px;
    margin-top: ${Spacings.SPACING_12B};
    flex-direction: column;
  }
`;

const BenefitsBox = styled.div`
  width: 336px;
  display: flex;
  flex-direction: column;
`;

const BenefitsBoxImage = styled.div`
  width: 80px;
`;

const StyledH4 = styled(H4)`
  margin-top: ${Spacings.SPACING_6B};
`;

const StyledP1 = styled(P1)`
  margin-top: ${Spacings.SPACING_2B};
  font-size: ${Fonts.LARGE};
`;

const CommunityBottomSection = () => {
  return (
    <Wrapper gridColumn="1/24">
      <StyledH1>India’s largest learning platform</StyledH1>
      <BenefitsContainer>
        <BenefitsBox>
          <BenefitsBoxImage>
            <Image
              src="community/community-staticEdu.svg"
              width={80}
              height={80}
              alt="edu"
            />
          </BenefitsBoxImage>
          <StyledH4>India’s best educators</StyledH4>
          <StyledP1>
            Learn live with India’s best educators and kick-start your
            preparation journey
          </StyledP1>
        </BenefitsBox>
        <BenefitsBox>
          <BenefitsBoxImage>
            <Image
              src="community/community-staticSyllabus.svg"
              width={80}
              height={80}
              alt="edu"
            />
          </BenefitsBoxImage>
          <StyledH4>Complete syllabus coverage</StyledH4>
          <StyledP1>
            All courses and batches are structured to help you complete the
            syllabus on time
          </StyledP1>
        </BenefitsBox>
        <BenefitsBox>
          <BenefitsBoxImage>
            <Image
              src="community/community-staticDoubts.svg"
              width={80}
              height={80}
              alt="edu"
            />
          </BenefitsBoxImage>
          <StyledH4>Live doubt solving and tests</StyledH4>
          <StyledP1>
            Boost your preparation with our regular mock tests and get detailed
            performance analysis
          </StyledP1>
        </BenefitsBox>
      </BenefitsContainer>
    </Wrapper>
  );
};

export default CommunityBottomSection;
